import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SubSection, SubSectionTitle } from './styles';

const ExpertiseSubSection = styled(SubSection)`
  margin-bottom: 48px;
`;

const Container = styled.ul`
  display: flex;
  flex-flow: row wrap;
  list-style: none;
  margin-top: 15px;
  padding: 0;
  margin-bottom: -16px;
`;

const Item = styled.li`
  margin-right: 16px;
  margin-bottom: 16px;
`;

const Link = styled.a`
  border-radius: 6px;
  background-color: #F0F3F6;
  color: #899EB1;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 14px;
  line-height: 120%;
  height: 32px;
  padding: 8px 15px;

  &:hover {
    text-decoration: none !important;
    color: #899EB1;
    background-color: ${props => props.theme.secondaryColorLight};
  }
`;

export default function Expertise({ areasOfExpertise }) {
  if (areasOfExpertise.length === 0) {
    return null;
  }

  return (
    <ExpertiseSubSection>
      <SubSectionTitle>Expertise</SubSectionTitle>
      <Container>
        {areasOfExpertise.map(expertise => (
          <Item key={expertise.slug}>
            <Link href={`/profiles/experts_in/${expertise.slug}`}>
              {expertise.name}
            </Link>
          </Item>
        ))}
      </Container>
    </ExpertiseSubSection>
  );
}

Expertise.propTypes = {
  areasOfExpertise: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string,
    name: PropTypes.string,
  })).isRequired,
};
